export default __webpack_public_path__ + "static/media/heroOrbs.37c8374c.png";